import FilterParameter from './FilterParameter'
import './OptionalFilter.scoped.scss'

const OPTIONAL_FIELD_DEFAULTS = {
  date_range: {},
  number_range: { operator: '>=', value: '' },
}

function getOptionalFieldDefault(fieldConfig) {
  if (OPTIONAL_FIELD_DEFAULTS[fieldConfig.type]) return OPTIONAL_FIELD_DEFAULTS[fieldConfig.type]
  return ''
}

export const OptionalField = ({ ruleId, fieldName, fieldConfig }) => {
  const act = useAct()
  const { parameters } = useSel((s) => s.rules.entities[ruleId])
  const isExpanded = parameters[fieldName] !== undefined

  function activate() {
    act.search.upsertFilterParameters(ruleId, { [fieldName]: getOptionalFieldDefault(fieldConfig) })
  }

  function remove() {
    act.search.removeFilterParameters(ruleId, [fieldName])
  }

  if (!isExpanded) return null

  return (
    <div className="sub-filter">
      <div className="left components">
        <span className="label bold">{(fieldConfig.label || fieldName).replace(/^\+ ?/, '')}</span>
        <FilterParameter id={ruleId} name={fieldName} fields={{ [fieldName]: fieldConfig }} />
      </div>
      <div className="right">
        <a className="link naked blue-link" onClick={remove}>Remove</a>
      </div>
    </div>
  )
}

export const OptionalFieldPopover = ({ ruleId, optionalFields, parameters, optionalFilterLabel }) => {
  const act = useAct()
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)

  const collapsedFields = optionalFields.filter(([fieldName]) => parameters[fieldName] === undefined)
  const anyExpanded = optionalFields.some(([fieldName]) => parameters[fieldName] !== undefined)

  useEffect(() => {
    const close = (event) => {
      if (menuRef.current && !event.composedPath().includes(menuRef.current)) {
        setOpen(false)
      }
    }
    document.addEventListener('click', close)
    return () => document.removeEventListener('click', close)
  }, [menuRef])

  if (collapsedFields.length === 0) return null

  function activate(fieldName, fieldConfig) {
    act.search.upsertFilterParameters(ruleId, { [fieldName]: getOptionalFieldDefault(fieldConfig) })
    setOpen(false)
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} ref={menuRef}>
      <a className="link naked blue-link" onClick={() => setOpen(!open)}>
        {anyExpanded ? 'filter further' : optionalFilterLabel}
      </a>
      {open && (
        <div className="popup popup-list" style={{ position: 'absolute', left: 0, marginTop: '10px', zIndex: 100 }}>
          <div className="list">
            {collapsedFields.map(([fieldName, fieldConfig]) => (
              <div key={fieldName} className="item" style={{ cursor: 'pointer' }} onClick={() => activate(fieldName, fieldConfig)}>
                {(fieldConfig.label || fieldName).replace(/^\+ ?/, '')}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
